export default __webpack_public_path__ + "static/media/FACINGS_Logo_Negative.36a3b8b2.png";